import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AzureMap,
  AzureMapDataSourceProvider,
  AzureMapFeature,
  AzureMapLayerProvider,
  AzureMapsProvider,
  AzureMapHtmlMarker,
  IAzureMapOptions,
  AzureMapPopup,
} from "react-azure-maps";
import {
  Autocomplete,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import {
  AuthenticationType,
  data,
  MapMouseEvent,
  PopupOptions,
} from "azure-maps-control";
import * as atlas from "azure-maps-control";

import { key } from "./key";
// import { carData } from "./data";
// import NewMarker2 from "../../Assests/NewMarker2.svg";
// import NewMarker1 from "../../Assests/NewMarker1.svg";

import marker3 from "../../Assests/marker3.svg";
import marker1 from "../../Assests/marker1.svg";
import products from "../../Assests/marker2.svg";
import capacity from "../../Assests/processing-plant-capacity.svg";
import inBoundLine from "../../Assests/inbound-line.svg";
import locator from "../../Assests/locator.svg";

//
import processingPlant from "../../Assests/processing-plant.svg";
import processingPlantAdd from "../../Assests/processing-plant-add.svg";
import processingPlantCapacity from "../../Assests/processing-plant-capacity.svg";
import processingPlantRemove from "../../Assests/processing-plant-remove.svg";
import packagingPlant1 from "../../Assests/packaging-plant-blue.svg";
import packagingPlant2 from "../../Assests/packaging-plant-green.svg";
import packagingPlantCapacity from "../../Assests/packaging-plant-capacity.svg";
import packagingPlantRemove from "../../Assests/packaging-plant-remove.svg";
import supplierMap from "../../Assests/supplier.svg";
import inBoundtoSupplier from "../../Assests/inbound-to-supplier.svg";

import "./style.css";
import { memo, useEffect, useMemo, useRef, useState } from "react";
import { popup } from "react";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import {
  API_BASE_URL,
  GET_AZURE_MAP_DATA,
  NUTRITION_GET_AZURE_MAP_DATA,
} from "../../Utils/Config";
import { getRequest } from "../../Services/AxiosConfiguration";
import { red } from "@mui/material/colors";
import Loader from "../../Components/Modals/Loader";
import { MultiSelect } from "react-multi-select-component";
// import RestoreOutlined from '@mui/icons-material/RestoreOutlined';
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
let current = "";
let toCheck = {
  factory: false,
  format: false,
  basepack: false,
  depot: false,
};

export default function Home2() {
  const [resultData, setResultData] = useState({});
  const [nutritionResultData, setNUTRITIONResultData] = useState({});
  const [show1, setShow1] = useState(true);
  const [show2, setShow2] = useState(true);
  const [show3, setShow3] = useState(true);
  const [show4, setShow4] = useState(true);
  const [factoryList, setFactoryList] = useState([]);
  const [formatList, setFormatList] = useState([]);
  const [basepackList, setBasepackList] = useState([]);
  const [depotList, setDepotList] = useState([]);
  const [selectedFactory, setSelectedFactory] = useState([]);
  const [selectedFormat, setSelectedFormat] = useState([]);
  const [selectedDepot, setSelectedDepot] = useState([]);
  const [selectedBasepack, setSelectedBasepack] = useState([]);
  const [filterTableData, setFilterTableData] = useState([]);
  const [viewDetail, setViewDetail] = useState(false);
  const [currentDetail, setCurrentDetail] = useState({});
  const [toggle, setToggle] = useState(true);

  //Nutrition
  const [nProcessingList, setNProcessingList] = useState([]);
  const [nFormatList, setNFormatList] = useState([]);
  const [nBasepackList, setNBasepackList] = useState([]);
  const [nDepotList, setNDepotList] = useState([]);
  const [nPackagingList, setNPackagingList] = useState([]);
  const [nSFGList, setNSFGList] = useState([]);
  const [selectedNFormat, setSelectedNFormat] = useState([]);
  const [selectedNDepot, setSelectedNDepot] = useState([]);
  const [selectedNBasepack, setSelectedNBasepack] = useState([]);
  const [selectedNSFG, setSelectedNSFG] = useState([]);
  const [selectedNPackaging, setSelectedNPackaging] = useState([]);
  const [selectedNProcessing, setSelectedNProcessing] = useState([]);
  const [proPlant, setProPlant] = useState(false);
  const [depotShow, setDepotShow] = useState(false);
  const [proPlantL, setProPlantL] = useState(false);
  const [packPlantShow, setPackPlantShow] = useState(false);
  const [depotShowL, setDepotShowL] = useState(false);

  useEffect(() => {
    console.log("resultData", resultData);
    resetFilter();
  }, [resultData]);

  useEffect(() => {
    console.log("resultData", resultData);
    resetNFilter();
  }, [nutritionResultData]);

  useEffect(() => {
    console.log("coordinates value : ", coordinates);
    let coordOutput = [];
    coordinates.forEach((each) => {
      let flag = false;
      for (let i = 0; i < filterTableData.length; i++) {
        if (filterTableData[i].depot === each.text) {
          flag = true;
          break;
        }
      }
      if (flag) {
        coordOutput.push({ ...each, show: true });
      } else {
        coordOutput.push([{ ...each, show: false }]);
      }
    });
    coordinates = [...coordOutput];
    console.log("new coordinate value : ", coordinates);
    setToggle(!toggle);
  }, [filterTableData]);

  const checkDepotToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].depot === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const checkPackagingToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].packing === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const checkProcessingToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].processing === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const checkFactoryToShow = (each) => {
    let coordOutput = [];

    let flag = false;
    for (let i = 0; i < filterTableData.length; i++) {
      if (filterTableData[i].factory_Code === each.text) {
        flag = true;
        break;
      }
    }
    if (flag) {
      return true;
    } else {
      // coordOutput.push([{ ...each, show: false }]);
      return false;
    }

    // coordinates = [...coordOutput];
    // console.log('new coordinate value : ', coordinates);
  };

  const factoryChanged = () => {
    let res = [];
    let fmList = [],
      bpList = [],
      dpList = [];
    resultData?.azureMapsSTHCFilterModel?.forEach((each) => {
      if (selectedFactory.length === 0) {
        res.push(each);
      } else {
        if (selectedFactory?.some((item) => item.key === each.factory_Code)) {
          res.push(each);
        }
      }
    });

    res.forEach((each) => {
      if (each.depot) {
        if (!dpList.some((item) => item.key === each.depot)) {
          dpList.push({ key: each.depot, value: each.depot });
        }
      }

      if (each.format) {
        if (!fmList.some((item) => item.key === each.format)) {
          fmList.push({ key: each.format, value: each.format });
        }
      }

      if (each.basepack_Code) {
        if (!bpList.some((item) => item.key === each.basepack_Code)) {
          bpList.push({ key: each.basepack_Code, value: each.basepack_Code });
        }
      }
    });

    setSelectedDepot([]);
    setSelectedFormat([]);
    setSelectedBasepack([]);

    setDepotList([...dpList]);

    setFormatList([...fmList]);

    setBasepackList([...bpList]);

    setFilterTableData([...res]);
  };

  const depotChanged = () => {
    let searchList = [];
    resultData?.azureMapsSTHCFilterModel?.forEach((each) => {
      if (selectedFactory.length === 0) {
        searchList.push(each);
      } else {
        if (selectedFactory?.some((item) => item.key === each.factory_Code)) {
          searchList.push(each);
        }
      }
    });

    console.log("searchList 1 ", searchList);

    let res = [];
    let fmList = [],
      bpList = [];
    searchList?.forEach((each) => {
      if (selectedDepot.length === 0) {
        res.push(each);
      } else {
        if (selectedDepot?.some((item) => item.key === each.depot)) {
          res.push(each);
        }
      }
    });

    res.forEach((each) => {
      if (each.format) {
        if (!fmList.some((item) => item.key === each.format)) {
          fmList.push({ key: each.format, value: each.format });
        }
      }

      if (each.basepack_Code) {
        if (!bpList.some((item) => item.key === each.basepack_Code)) {
          bpList.push({ key: each.basepack_Code, value: each.basepack_Code });
        }
      }
    });

    setSelectedFormat([]);
    setSelectedBasepack([]);

    setFormatList([...fmList]);
    setBasepackList([...bpList]);

    setFilterTableData([...res]);
  };

  const formatChanged = () => {
    let searchList = [];
    resultData?.azureMapsSTHCFilterModel?.forEach((each) => {
      if (selectedFactory.length === 0) {
        searchList.push(each);
      } else {
        if (selectedFactory?.some((item) => item.key === each.factory_Code)) {
          searchList.push(each);
        }
      }
    });
    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedDepot.length === 0) {
        searchList.push(each);
      } else {
        if (selectedDepot?.some((item) => item.key === each.depot)) {
          searchList.push(each);
        }
      }
    });
    let res = [];

    let bpList = [];
    searchList?.forEach((each) => {
      if (selectedFormat.length === 0) {
        res.push(each);
      } else {
        if (selectedFormat?.some((item) => item.key === each.format)) {
          res.push(each);
        }
      }
    });

    res.forEach((each) => {
      if (each.basepack_Code) {
        if (!bpList.some((item) => item.key === each.basepack_Code)) {
          bpList.push({ key: each.basepack_Code, value: each.basepack_Code });
        }
      }
    });

    setSelectedBasepack([]);

    setBasepackList([...bpList]);

    setFilterTableData([...res]);
  };

  const basepackChanged = () => {
    let searchList = [];
    resultData?.azureMapsSTHCFilterModel?.forEach((each) => {
      if (selectedFactory.length === 0) {
        searchList.push(each);
      } else {
        if (selectedFactory?.some((item) => item.key === each.factory_Code)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedDepot.length === 0) {
        searchList.push(each);
      } else {
        if (selectedDepot?.some((item) => item.key === each.depot)) {
          searchList.push(each);
        }
      }
    });

    let searchList3 = [...searchList];
    searchList = [];

    searchList3?.forEach((each) => {
      if (selectedFormat.length === 0) {
        searchList.push(each);
      } else {
        if (selectedFormat?.some((item) => item.key === each.format)) {
          searchList.push(each);
        }
      }
    });

    let res = [];

    searchList?.forEach((each) => {
      if (selectedBasepack.length === 0) {
        res.push(each);
      } else {
        if (selectedBasepack?.some((item) => item.key === each.basepack_Code)) {
          res.push(each);
        }
      }
    });

    setFilterTableData([...res]);
  };

  const processingNChanged = () => {
    let res = [];
    let nSFGL = [],
      nPackagingL = [],
      nBasepackL = [],
      nFormatL = [],
      nDepotL = [];
    nutritionResultData?.azureMapsSTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        res.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          res.push(each);
        }
      }
    });

    res.forEach((each) => {
      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }

      if (each.format) {
        if (!nFormatL.some((item) => item.key === each.format)) {
          nFormatL.push({ key: each.format, value: each.format });
        }
      }

      if (each.basepack) {
        if (!nBasepackL.some((item) => item.key === each.basepack)) {
          nBasepackL.push({ key: each.basepack, value: each.basepack });
        }
      }

      if (each.packing) {
        if (!nPackagingL.some((item) => item.key === each.packing)) {
          nPackagingL.push({ key: each.packing, value: each.packing });
        }
      }

      if (each.sfg) {
        if (!nSFGL.some((item) => item.key === each.sfg)) {
          nSFGL.push({ key: each.sfg, value: each.sfg });
        }
      }
    });

    // setSelectedNProcessing("Processing");
    setSelectedNSFG([]);
    setSelectedNPackaging([]);
    setSelectedNBasepack([]);
    setSelectedNFormat([]);
    setSelectedNDepot([]);

    // setNProcessingList([...nProcessingL]);
    setNSFGList([...nSFGL]);
    setNPackagingList([...nPackagingL]);
    setNBasepackList([...nBasepackL]);
    setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);

    setFilterTableData([...res]);
  };

  const SFGNChanged = () => {
    let searchList = [];
    nutritionResultData?.azureMapsSTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          searchList.push(each);
        }
      }
    });

    let res = [];
    let nPackagingL = [],
      nBasepackL = [],
      nFormatL = [],
      nDepotL = [];
    searchList?.forEach((each) => {
      if (selectedNSFG.length === 0) {
        res.push(each);
      } else {
        if (selectedNSFG?.some((item) => item.key === each.sfg)) {
          res.push(each);
        }
      }
    });

    console.log("searchList 2 res", res);

    res.forEach((each) => {
      if (each.packing) {
        if (!nPackagingL.some((item) => item.key === each.packing)) {
          nPackagingL.push({ key: each.packing, value: each.packing });
        }
      }

      if (each.basepack) {
        if (!nBasepackL.some((item) => item.key === each.basepack)) {
          nBasepackL.push({ key: each.basepack, value: each.basepack });
        }
      }

      if (each.format) {
        if (!nFormatL.some((item) => item.key === each.format)) {
          nFormatL.push({ key: each.format, value: each.format });
        }
      }

      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }
    });

    // setSelectedNProcessing("Processing");
    // setSelectedNSFG("SFG");
    setSelectedNPackaging([]);
    setSelectedNBasepack([]);
    setSelectedNFormat([]);
    setSelectedNDepot([]);

    // setNProcessingList([...nProcessingL]);
    // setNSFGList([...nSFGL]);
    setNPackagingList([...nPackagingL]);
    setNBasepackList([...nBasepackL]);
    setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);

    setFilterTableData([...res]);
  };

  const packagingNChanged = () => {
    let searchList = [];
    nutritionResultData?.azureMapsSTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedNSFG.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNSFG?.some((item) => item.key === each.sfg)) {
          searchList.push(each);
        }
      }
    });

    let res = [];
    let nBasepackL = [],
      nFormatL = [],
      nDepotL = [];
    searchList?.forEach((each) => {
      if (selectedNPackaging.length === 0) {
        res.push(each);
      } else {
        if (selectedNPackaging?.some((item) => item.key === each.packing)) {
          res.push(each);
        }
      }
    });

    console.log("searchList 2 res", res);

    res.forEach((each) => {
      if (each.basepack) {
        if (!nBasepackL.some((item) => item.key === each.basepack)) {
          nBasepackL.push({ key: each.basepack, value: each.basepack });
        }
      }

      if (each.format) {
        if (!nFormatL.some((item) => item.key === each.format)) {
          nFormatL.push({ key: each.format, value: each.format });
        }
      }

      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }
    });

    // setSelectedNProcessing("Processing");
    // setSelectedNSFG("SFG");
    // setSelectedNPackaging("Packaging");
    setSelectedNBasepack([]);
    setSelectedNFormat([]);
    setSelectedNDepot([]);

    // setNProcessingList([...nProcessingL]);
    // setNSFGList([...nSFGL]);
    // setNPackagingList([...nPackagingL]);
    setNBasepackList([...nBasepackL]);
    setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);

    setFilterTableData([...res]);
  };

  const basepackNChanged = () => {
    let searchList = [];
    nutritionResultData?.azureMapsSTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedNSFG.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNSFG?.some((item) => item.key === each.sfg)) {
          searchList.push(each);
        }
      }
    });

    let searchList3 = [...searchList];
    searchList = [];

    searchList3?.forEach((each) => {
      if (selectedNPackaging.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNPackaging?.some((item) => item.key === each.packing)) {
          searchList.push(each);
        }
      }
    });

    let res = [];
    let nFormatL = [],
      nDepotL = [];
    searchList?.forEach((each) => {
      if (selectedNBasepack.length === 0) {
        res.push(each);
      } else {
        if (selectedNBasepack?.some((item) => item.key === each.basepack)) {
          res.push(each);
        }
      }
    });

    console.log("searchList 2 res", res);

    res.forEach((each) => {
      if (each.format) {
        if (!nFormatL.some((item) => item.key === each.format)) {
          nFormatL.push({ key: each.format, value: each.format });
        }
      }

      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }
    });

    // setSelectedNProcessing("Processing");
    // setSelectedNSFG("SFG");
    // setSelectedNPackaging("Packaging");
    // setSelectedNBasepack("Basepack");
    setSelectedNFormat([]);
    setSelectedNDepot([]);

    // setNProcessingList([...nProcessingL]);
    // setNSFGList([...nSFGL]);
    // setNPackagingList([...nPackagingL]);
    // setNBasepackList([...nBasepackL]);
    setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);

    setFilterTableData([...res]);
  };

  const formatNChanged = () => {
    let searchList = [];
    nutritionResultData?.azureMapsSTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedNSFG.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNSFG?.some((item) => item.key === each.sfg)) {
          searchList.push(each);
        }
      }
    });

    let searchList3 = [...searchList];
    searchList = [];

    searchList3?.forEach((each) => {
      if (selectedNPackaging.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNPackaging?.some((item) => item.key === each.packing)) {
          searchList.push(each);
        }
      }
    });

    let searchList4 = [...searchList];
    searchList = [];

    searchList4?.forEach((each) => {
      if (selectedNBasepack.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNBasepack?.some((item) => item.key === each.basepack)) {
          searchList.push(each);
        }
      }
    });

    let res = [];
    let nDepotL = [];
    searchList?.forEach((each) => {
      if (selectedNFormat.length === 0) {
        res.push(each);
      } else {
        if (selectedNFormat?.some((item) => item.key === each.format)) {
          res.push(each);
        }
      }
    });

    console.log("searchList 2 res", res);

    res.forEach((each) => {
      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }
    });

    // setSelectedNProcessing("Processing");
    // setSelectedNSFG("SFG");
    // setSelectedNPackaging("Packaging");
    // setSelectedNBasepack("Basepack");
    // setSelectedNFormat("Format");
    setSelectedNDepot([]);

    // setNProcessingList([...nProcessingL]);
    // setNSFGList([...nSFGL]);
    // setNPackagingList([...nPackagingL]);
    // setNBasepackList([...nBasepackL]);
    // setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);

    setFilterTableData([...res]);
  };

  const depotNChanged = () => {
    let searchList = [];
    nutritionResultData?.azureMapsSTNutritionFilterModel?.forEach((each) => {
      if (selectedNProcessing.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNProcessing?.some((item) => item.key === each.processing)) {
          searchList.push(each);
        }
      }
    });

    let searchList2 = [...searchList];
    searchList = [];

    searchList2?.forEach((each) => {
      if (selectedNSFG.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNSFG?.some((item) => item.key === each.sfg)) {
          searchList.push(each);
        }
      }
    });

    let searchList3 = [...searchList];
    searchList = [];

    searchList3?.forEach((each) => {
      if (selectedNPackaging.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNPackaging?.some((item) => item.key === each.packing)) {
          searchList.push(each);
        }
      }
    });

    let searchList4 = [...searchList];
    searchList = [];

    searchList4?.forEach((each) => {
      if (selectedNBasepack.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNBasepack?.some((item) => item.key === each.basepack)) {
          searchList.push(each);
        }
      }
    });

    let searchList5 = [...searchList];
    searchList = [];

    searchList5?.forEach((each) => {
      if (selectedNFormat.length === 0) {
        searchList.push(each);
      } else {
        if (selectedNFormat?.some((item) => item.key === each.format)) {
          searchList.push(each);
        }
      }
    });

    let res = [];

    searchList?.forEach((each) => {
      if (selectedNDepot.length === 0) {
        res.push(each);
      } else {
        if (selectedNDepot?.some((item) => item.key === each.depot)) {
          res.push(each);
        }
      }
    });

    console.log("searchList 2 res", res);

    setFilterTableData([...res]);
  };

  useEffect(() => {
    processingNChanged();
  }, [selectedNProcessing]);

  useEffect(() => {
    SFGNChanged();
  }, [selectedNSFG]);

  useEffect(() => {
    packagingNChanged();
  }, [selectedNPackaging]);

  useEffect(() => {
    formatNChanged();
  }, [selectedNFormat]);

  useEffect(() => {
    basepackNChanged();
  }, [selectedNBasepack]);

  useEffect(() => {
    depotNChanged();
  }, [selectedNDepot]);

  //nutrition ends

  useEffect(() => {
    factoryChanged();
  }, [selectedFactory]);

  useEffect(() => {
    depotChanged();
  }, [selectedDepot]);

  useEffect(() => {
    formatChanged();
  }, [selectedFormat]);

  useEffect(() => {
    basepackChanged();
  }, [selectedBasepack]);

  // suren
  //legends show hide
  const [showLegendDetails, setshowLegendDetails] = useState(false);

  //map filters show hid
  const [showMapFiltersDetails, setshowMapFiltersDetails] = useState(false);

  const { selectedScenarioData } = useSelector(
    (state) => state.InputDataReducers,
  );
  console.log(
    selectedScenarioData?.scenario === "BaseLine",
    "selectedScenarioData",
  );

  const selectedUsecaseId = useSelector(
    (state) => state.InputDataReducers.selectedUsecaseId,
  );
  const selectedCategoryId = useSelector(
    (state) => state.InputDataReducers.selectedCategoryId,
  );

  const selectedFolderId = useSelector(
    (state) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScnarioId = useSelector(
    (state) => state.InputDataReducers.selectedScenarioId,
  );

  const selectedTimeId = useSelector(
    (state) => state.InputDataReducers.selectedTimeId,
  );

  useEffect(() => {
    setshowLegendDetails(false);
  }, [selectedFolderId, selectedScnarioId]);

  useEffect(() => {
    if (selectedCategoryId === 1) {
      getAzureMapData(
        selectedUsecaseId,
        selectedCategoryId,
        selectedFolderId,
        selectedScnarioId,
        "Time_Period",
      );
      setshowMapFiltersDetails(false);
      setViewDetail(false);
    } else {
      nutritionGetAzureMapData(
        selectedUsecaseId,
        selectedCategoryId,
        selectedFolderId,
        selectedScnarioId,
        "Time_Period",
      );
      setshowMapFiltersDetails(false);
      setViewDetail(false);
    }

    //callFolderFilterApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScnarioId,
    selectedTimeId,
  ]);
  //let resultData={};
  const getAzureMapData = (
    usecaseId,
    category_Id,
    folder_id,
    scenarioId,
    Time_Period,
  ) => {
    const urls = API_BASE_URL + GET_AZURE_MAP_DATA;
    const header = {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    };
    getRequest(
      // urls,
      API_BASE_URL + "/baselinecost/shortterm/homecare/maps",
      {
        usecaseId: usecaseId,
        category_Id: category_Id,
        folder_id: folder_id,
        scenario_id: scenarioId,
        Time_Period: Time_Period,
      },
      header,
    )
      .then((response) => {
        console.log("Response: ", response);
        //dispatch(getScenarioNumberSuccess(response.data));
        //let dataResult = JSON.parse(response.data);
        //console.log("JSON Parse", dataResult)
        let result = response.data;
        setResultData(result);
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        // dispatch(getScenarioNumberError(error));
      });
  };
  const nutritionGetAzureMapData = (
    usecaseId,
    category_Id,
    folder_id,
    scenarioId,
    Time_Period,
  ) => {
    const urls = API_BASE_URL + NUTRITION_GET_AZURE_MAP_DATA;
    const header = {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    };
    getRequest(
      // urls,
      API_BASE_URL + "/baselinecost/shortterm/nutrition/maps",
      {
        usecaseId: usecaseId,
        category_Id: category_Id,
        folder_id: folder_id,
        scenario_id: scenarioId,
        Time_Period: Time_Period,
      },
      header,
    )
      .then((response) => {
        //   console.log('Response: ', response);
        //dispatch(getScenarioNumberSuccess(response.data));
        console.log("Map", response.data);
        //let dataResult = JSON.parse(response.data);
        //console.log("JSON Parse", dataResult)
        let result = response.data;
        // let nutFilterObject = [];
        // response?.data?.azureMapsSTNutritionFilterModel?.forEach((each) => {
        //   let obj = { ...each };
        //   obj.factory_Code = each.processing;
        //   obj.basepack_Code = each.basepack;
        //   nutFilterObject.push(obj);
        // })

        // result.azureMapsSTHCFilterModel = nutFilterObject;

        // setResultData(result);
        setNUTRITIONResultData(result);
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        // dispatch(getScenarioNumberError(error));
      });
  };
  const nutritionPoints =
    nutritionResultData?.nutritionAzureMapsModel?.points?.length > 0
      ? nutritionResultData?.nutritionAzureMapsModel?.points
      : [];

  const points =
    resultData?.azureMapsModel?.points?.length > 0
      ? resultData?.azureMapsModel?.points
      : [
          // {
          //   source: [76.1456, 30.3647],
          //   destination: [77.8271, 12.7280],
          // },
          // {
          //   source: [76.1456, 30.3647],
          //   destination: [77.8271, 12.7280],
          // },
          // {
          //   source:[77.8271, 12.7280],
          //   destination: [72.5918, 23.0145],
          // },
          // {
          //   source: [76.1456, 30.3647],
          //   destination: [77.5667, 12.9667],
          // },
          // {
          //   source:[77.5667, 12.9667],
          //   destination: [72.5918, 23.0145],
          // },
          // {
          //   source:[77.8271, 12.7280],
          //   destination: [77.7200, 13.4300],
          // },
          // {
          //   source:[77.5667, 12.9667],
          //   destination: [77.7200, 13.4300],
          // },
        ];

  let nutritionCoordinates =
    nutritionResultData?.nutritionAzureMapsModel?.coordinates?.length > 0
      ? nutritionResultData?.nutritionAzureMapsModel?.coordinates
      : [];
  let coordinates =
    resultData?.azureMapsModel?.coordinates?.length > 0
      ? resultData?.azureMapsModel?.coordinates
      : [
          // {
          //   latitude: 23.0145,
          //   longitude: 72.5918,
          //   text: "Ahmedabad",
          //   title: "Ahmedabad"
          // },
          // {
          //   latitude: 13.4300,
          //   longitude: 77.7200,
          //   text: "Chikkaballapur",
          //   title: "Chikkaballapur"
          // }
        ];

  const nutritionPackaging =
    nutritionResultData?.nutritionAzureMapsModel?.packagingCoords?.length > 0
      ? nutritionResultData?.nutritionAzureMapsModel?.packagingCoords
      : [];

  // {
  //   latitude: 12.9667,
  //   longitude: 77.5667,
  //   title: "Rohini Packer",
  //   text: "Rohini Packer",
  // },

  // {
  //   latitude: 12.7280,
  //   longitude: 77.8271,
  //   text: "Hosur",
  //   title: "Hosur"

  // }

  const nutritionFactoryCoords =
    nutritionResultData?.nutritionAzureMapsModel?.factoryCoords?.length > 0
      ? nutritionResultData?.nutritionAzureMapsModel?.factoryCoords
      : [];

  const factoryCoords =
    resultData?.azureMapsModel?.factoryCoords?.length > 0
      ? resultData?.azureMapsModel?.factoryCoords
      : [
          //  {
          //   latitude: 12.9667,
          //   longitude: 77.5667,
          //   title: "Rohini Packer",
          //   text: "Rohini Packer",
          // },
          //  {
          //   latitude: 30.3647,
          //   longitude: 76.1456,
          //   title: "Nabha",
          //   text: "Nabha",
          // }
        ];

  let popUpContent = [];
  let popupPosition = "";
  function mouseOverLineString(e) {
    popUpContent = [];
    const ele = e.target?.element;
    console.log(e.target?.options, "contentttt");
    if (e.target && e.target?.options?.position?.length > 0) {
      if (e.target?.options?.htmlContent.toString().includes("marker1")) {
        popupPosition = "Depo";
      } else if (
        e.target?.options?.htmlContent.toString().includes("marker2")
      ) {
        popupPosition = "Packaging";
      } else {
        popupPosition = "Factory";
      }
      popUpContent.push(e.target?.options?.position, e.target?.options?.text);
    }
  }

  const onClick = (e) => {
    atlas.Popup(true);
  };

  const eventToMarker = [
    {
      // eventName: "mousemove", callback: mouseOverLineString,
      eventName: "mousemove",
      callback: null,
    },
  ];

  const mapPointClicked = (det, heading, imgUrl) => {
    console.log("map ddetais", det);
    if (selectedCategoryId === 1) {
      if (heading === "Depot") {
        setSelectedDepot([
          {
            key: det.text,
            value: det.text,
          },
        ]);
      } else {
        setSelectedFactory([
          {
            key: det.text,
            value: det.text,
          },
        ]);
      }
    } else {
      if (heading === "Depot") {
        setSelectedNDepot([
          {
            key: det.text,
            value: det.text,
          },
        ]);
      } else if (heading === "Packaging Plant") {
        setSelectedNPackaging([
          {
            key: det.text,
            value: det.text,
          },
        ]);
      } else {
        setSelectedNProcessing([
          {
            key: det.text,
            value: det.text,
          },
        ]);
      }
    }
    setshowLegendDetails(false);
    setshowMapFiltersDetails(true);
    setViewDetail(true);
    setCurrentDetail({ ...det, heading: heading, imgUrl: imgUrl });
    // setSelectedFactory(det.factory_Code);
    // setSelectedFactory("ABC")
  };

  const renderPoint = (data) => {
    let point1 = data.source;
    let point2 = data.destination;
    let out = curvePlot(point1, point2);
    return (
      <AzureMapFeature
        key={"Line String Feature"}
        id={"Line Strign ID"}
        type={"LineString"}
        coordinates={[...out]}
      />
    );
  };

  function renderHTMLPoint() {
    const rendId = Math.random();
    setDepotShow(false);
    setDepotShowL(false);
    if (coordinates?.length > 0) {
      setDepotShow(true);
    }
    if (nutritionCoordinates?.length > 0) {
      setDepotShowL(true);
    }
    return (
      <>
        {selectedCategoryId === 1 ? (
          <>
            {coordinates.map((coordinate, idx) => {
              return (
                // (selectedDepot === "Depot") || (selectedFactory === coordinate.text || selectedDepot === coordinate.text)
                checkDepotToShow(coordinate) ? (
                  <AzureMapHtmlMarker
                    key={idx}
                    markerContent={
                      <div>
                        <img
                          className={"marker-1-style"}
                          src={marker1}
                          title={"Depot: " + coordinate.text}
                        />

                        {/* <img className={"marker-1-style"} src={products} /> */}

                        {/* <img className={"marker-1-style"} src={NewMarker1} /> */}
                        {/* <img className={"marker-1-style"} src={NewMarker2} /> */}
                      </div>
                    }
                    options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                    // events={mapClick}
                    events={[
                      {
                        eventName: "click",
                        callback: () =>
                          mapPointClicked(coordinate, "Depot", marker1),
                      },
                    ]}
                  />
                ) : null
              );
            })}
          </>
        ) : (
          <>
            {nutritionCoordinates?.map((coordinate, idx) => {
              return (
                // (selectedDepot === "Depot") || (selectedFactory === coordinate.text || selectedDepot === coordinate.text)
                checkDepotToShow(coordinate) ? (
                  <AzureMapHtmlMarker
                    key={idx}
                    markerContent={
                      <div>
                        <img
                          className={"marker-1-style"}
                          src={marker1}
                          title={"Depot: " + coordinate.text}
                        />

                        {/* <img className={"marker-1-style"} src={products} /> */}

                        {/* <img className={"marker-1-style"} src={NewMarker1} /> */}
                        {/* <img className={"marker-1-style"} src={NewMarker2} /> */}
                      </div>
                    }
                    options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                    events={[
                      {
                        eventName: "click",
                        callback: () =>
                          mapPointClicked(coordinate, "Depot", marker1),
                      },
                    ]}
                  />
                ) : null
              );
            })}
          </>
        )}
        {/*
{states.map((state, idx) => {
        return (

          <AzureMapHtmlMarker
            key={idx}
            markerContent={
              <div>
                <img className={"marker-1-style"} src={marker4} />
              </div>
            }
            options={{ ...azureHtmlMapMarkerOptions(state) }}
            events={eventToMarker}
          />
        );
      })} */}
      </>
    );
  }

  function renderFactoryPoints() {
    const rendId = Math.random();
    setProPlant(false);
    setProPlantL(false);
    if (factoryCoords?.length > 0) {
      setProPlant(true);
    }
    if (nutritionFactoryCoords?.length > 0) {
      setProPlantL(true);
    }
    return (
      <>
        {selectedCategoryId === 1 ? (
          <>
            {factoryCoords.map((coordinate, idx) => {
              {
                /* {resultData && resultData?.factoryCoords && resultData?.factoryCoords.map((coordinate, idx) => { */
              }
              return (
                // (selectedFactory === "Factory") || (selectedFactory === coordinate.text)
                checkFactoryToShow(coordinate) ? (
                  <AzureMapHtmlMarker
                    key={idx}
                    markerContent={
                      <div>
                        <img
                          className={"marker-3-style"}
                          src={marker3}
                          title={"Processing Plant: " + coordinate.text}
                        />
                      </div>
                    }
                    options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                    events={[
                      {
                        eventName: "click",
                        callback: () =>
                          mapPointClicked(
                            coordinate,
                            "Processing Plant",
                            marker3,
                          ),
                      },
                    ]}
                  />
                ) : null
              );
            })}
          </>
        ) : (
          <>
            {nutritionFactoryCoords?.map((coordinate, idx) => {
              {
                /* {resultData && resultData?.factoryCoords && resultData?.factoryCoords.map((coordinate, idx) => { */
              }
              return (
                // (selectedFactory === "Factory") || (selectedFactory === coordinate.text || selectedDepot === coordinate.text)
                checkProcessingToShow(coordinate) ? (
                  <AzureMapHtmlMarker
                    key={idx}
                    markerContent={
                      <div>
                        <img
                          className={"marker-3-style"}
                          src={marker3}
                          // onMouseEnter={mouseOverLineString}
                          title={"Processing Plant: " + coordinate.text}
                        />
                      </div>
                    }
                    options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                    events={[
                      {
                        eventName: "click",
                        callback: () =>
                          mapPointClicked(
                            coordinate,
                            "Processing Plant",
                            marker3,
                          ),
                      },
                    ]}
                  />
                ) : null
              );
            })}
          </>
        )}
      </>
    );
  }

  function renderPackagingPoints() {
    const rendId = Math.random();
    setPackPlantShow(false);
    if (nutritionPackaging?.length > 0) {
      setPackPlantShow(true);
    }
    return (
      <>
        {nutritionPackaging?.map((packaging, idx) => {
          return (
            // (selectedFactory === "Factory") || (selectedFactory === packaging.text || selectedDepot === packaging.text)
            checkPackagingToShow(packaging) ? (
              <AzureMapHtmlMarker
                key={idx}
                markerContent={
                  <div>
                    <img
                      className={"marker-1-style"}
                      title={"Packaging Plant: " + packaging.text}
                      src={products}
                    />
                  </div>
                }
                options={{ ...azureHtmlMapMarkerOptions(packaging) }}
                events={[
                  {
                    eventName: "click",
                    callback: () =>
                      mapPointClicked(packaging, "Packaging Plant", products),
                  },
                ]}
              />
            ) : null
          );
        })}

        {/*
{states.map((state, idx) => {
        return (

          <AzureMapHtmlMarker
            key={idx}
            markerContent={
              <div>
                <img className={"marker-1-style"} src={marker4} />
              </div>
            }
            options={{ ...azureHtmlMapMarkerOptions(state) }}
            events={eventToMarker}
          />
        );
      })} */}
      </>
    );
  }

  function azureHtmlMapMarkerOptions(coordinate) {
    return {
      //position: [coordinate.latitude, coordinate.longitude],
      position: [coordinate.longitude, coordinate.latitude],
      text: coordinate.text,
      title: coordinate.title,
    };
  }

  const curvePlot = (point1, point2) => {
    let startX = point1[0];
    let startY = point1[1];

    let endX = point2[0];
    let endY = point2[1];

    let centerX = (startX + endX) / 2;
    let centerY = (startY + endY) / 2;

    let slope = (endY - startY) / (endX - startX);
    let c1 = endY - slope * endX;
    let nslope = (1 / slope) * -1;
    let c = slope * centerX + centerX / slope + c1; //c for perpendicular line
    //eq of perpendicular line : y = (-1/slope)x + c

    //Now solve quadratic eq: ax2 + bx + c2 = 0
    let a = 1 + nslope * nslope;
    let b = 2 * nslope * c - 2 * centerX - 2 * nslope * centerY;
    let c2 =
      centerX * centerX + centerY * centerY + c * c - 2 * centerY * c - 2;

    let reqX = (-b - Math.sqrt(Math.abs(b * b - 4 * a * c2))) / (2 * a);
    let reqY = nslope * reqX + c;

    let out = [];
    out.push(point1);

    let bezierX = reqX;
    let bezierY = reqY;

    // for (let t = 0.0; t <= 1; t += 0.01) {
    //   let x =
    //     (1 - t) * (1 - t) * startX + 2 * (1 - t) * t * bezierX + t * t * endX;
    //   let y =
    //     (1 - t) * (1 - t) * startY + 2 * (1 - t) * t * bezierY + t * t * endY;
    //   out.push([x, y]);
    // }
    out.push(point2);
    return out;
  };
  console.log(curvePlot, "curvePlot");
  // curvePlot?.setProperty('strokeColor', 'red')

  const renderMarker = () => {
    const rendId = Math.random();

    return (
      <AzureMapFeature
        key={rendId}
        id={rendId.toString()}
        type="Point"
        coordinate={coordinates}
        nutritionPackaging={nutritionPackaging}
        // state = {states}
        properties={{
          title: "Pin",
          icon: "pin-round-blue",
        }}
      />
    );
  };

  const calculateDistance = (point1, point2) => {
    let dis =
      Math.pow(point1[0] - point2[0], 2) + Math.pow(point1[1] - point2[1], 2);
    return Math.sqrt(dis);
  };

  const renderLegendOptions = () => {
    let uc = localStorage.getItem("selectedUsecase");
    let sr = localStorage.getItem("selectedRadio");
    // let ucid = uc == "Short Term" ? 1 : 2;
    // let srid = sr == "masterData" ? 1 : 2;

    if (uc === "Short Term" && sr === "masterData") {
      return (
        <div className="legends-panel ">
          {proPlant && (
            <ul>
              <li>
                <img src={marker3}></img>
              </li>
              <li>
                <span>Processing Factory</span>
              </li>
              <li></li>
              <li>
                <input
                  checked={show2}
                  onChange={(v) => setShow2(v.target.checked)}
                  type="checkbox"
                  className="pull-right"
                />
              </li>
            </ul>
          )}
          {depotShow && (
            <ul>
              <li>
                <img src={locator}></img>
              </li>
              <li>
                <span>Depot</span>
              </li>
              <li></li>
              <li>
                <input
                  checked={show3}
                  onChange={(v) => setShow3(v.target.checked)}
                  type="checkbox"
                  className="pull-right"
                />
              </li>
            </ul>
          )}
          <ul>
            <li>
              <span className="barliine">____</span>
            </li>
            <li>
              <span>Out-bound to Depots</span>
            </li>
            <li></li>
          </ul>
        </div>
      );
    } else if (uc === "Short Term" && sr === "inputData") {
      return (
        <div className="legends-panel ">
          {proPlantL && (
            <ul>
              <li>
                <img src={marker3}></img>
              </li>
              <li>
                <span>Processing Factory</span>
              </li>
              <li></li>
              <li>
                <input
                  checked={show2}
                  onChange={(v) => setShow2(v.target.checked)}
                  type="checkbox"
                  className="pull-right"
                />
              </li>
            </ul>
          )}

          {packPlantShow && (
            <ul>
              <li>
                <img src={packagingPlant1}></img>
              </li>
              <li>
                <span>Packaging Factory</span>
              </li>
              <li></li>
              <li>
                <input
                  checked={show4}
                  onChange={(v) => setShow4(v.target.checked)}
                  type="checkbox"
                  className="pull-right"
                />
              </li>
            </ul>
          )}

          {depotShowL && (
            <ul>
              <li>
                <img src={locator}></img>
              </li>
              <li>
                <span>Depots</span>
              </li>
              <li></li>
              <li>
                <input
                  checked={show3}
                  onChange={(v) => setShow3(v.target.checked)}
                  type="checkbox"
                  className="pull-right"
                />
              </li>
            </ul>
          )}

          <ul>
            <li>
              <span className="barliine"> ____</span>
            </li>
            <li>
              <span>Out-bound to Depots</span>
            </li>
            <li></li>
          </ul>
          {/* <ul>
            <li><span className="barliine">____</span></li>

            <li><span>In-bound to packaging plant from Processing plant</span></li>
            <li></li>
            <li><input type="checkbox" className="pull-right" /></li>
          </ul> */}
        </div>
      );
    } else if (uc === "Medium Term" && sr === "masterData") {
      return (
        <div className="legends-panel ">
          <ul>
            <li>
              <img src={processingPlant}></img>
            </li>
            <li>
              <span>Proccessing Plant</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>
          <ul>
            <li>
              <img src={processingPlantCapacity}></img>
            </li>
            <li>
              <span>Proccessing Plant Capacity Add</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>

          <ul>
            <li>
              <img src={locator}></img>
            </li>
            <li>
              <span>Depots</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>
          <ul>
            <li>
              <span className="barliine">____</span>
            </li>
            <li>
              <span>Out-bound to Depot</span>
            </li>
            <li></li>
          </ul>
        </div>
      );
    } else {
      return (
        <div className="legends-panel ">
          <ul>
            <li>
              <img src={locator}></img>
            </li>
            <li>
              <span>Depots</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>

          <ul>
            <li>
              <span className="barliine">____</span>
            </li>

            <li>
              <span>In-bound to packaging plant from Processing plant</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>

          <ul>
            <li>
              <span className="barliine">____</span>
            </li>
            <li>
              <span>In-bound to Depot from Packaging</span>
            </li>
            <li></li>
          </ul>

          <ul>
            <li>
              <img src={processingPlant}></img>
            </li>
            <li>
              <span>Proccessing Plant</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>
          <ul>
            <li>
              <img src={processingPlantCapacity}></img>
            </li>
            <li>
              <span>Proccessing Plant Capacity Add</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>
          <ul>
            <li>
              <img src={marker3}></img>
            </li>
            <li>
              <span>Packaging</span>
            </li>
            <li></li>
            {/* <li><input type="checkbox" className="pull-right" /></li> */}
          </ul>
        </div>
      );
    }
  };

  <AzureMapFeature
    key={data.licensePlate}
    id={data.licensePlate}
    type="Point"
    coordinate={data}
    packaging={data}
    state={data}
    properties={{
      id: data.licensePlate,
      popUpProp: data,
    }}
  />;

  const MarkersExample = () => {
    // const [mapData, setMapData] = useState([...carData]);
    // const [mapData, setMapData] = useState([...points]);
    const [popupProperties, setPopupProperties] = useState("");
    const [popupOptions, setPopupOptions] = useState({});
    const option = useMemo(() => {
      return {
        authOptions: {
          authType: AuthenticationType.subscriptionKey,
          subscriptionKey: key,
        },
        //center: mapData.position,
        //center: [carData.position.latitude, carData.position.longitude],
        center: [77.580643, 20.972442],
        zoom: 3.4,
        view: "Auto",
        visibility: "off",

        // scrollZoomInteraction: coordinates && coordinates.length > 0 ? true : false
      };
    }, []);

    var popup = new atlas.Popup({});
    const mapRef = useRef(null);

    const handleZoom = (e) => {
      const zoomLevel = e?.map?.map?.getZoom();
      if (zoomLevel > 0) {
        let layers = e?.map?.map?.getStyle().layers;

        for (let i = 0; i < layers.length; i++) {
          if (
            layers[i].type == "symbol" &&
            layers[i].source == "vectorTiles" &&
            layers[i].layout &&
            layers[i].layout["text-field"] &&
            layers[i].layout["text-field"] !== ""
          ) {
            e?.map?.map?.setLayoutProperty(layers[i].id, "visibility", "none");
          }
        }
      } else {
        let layers = e?.map?.map?.getStyle().layers;
        for (let i = 0; i < layers.length; i++) {
          if (
            layers[i].type == "symbol" &&
            layers[i].source == "vectorTiles" &&
            layers[i].layout &&
            layers[i].layout["text-field"] &&
            layers[i].layout["text-field"] !== ""
          ) {
            e?.map?.map.setLayoutProperty(layers[i].id, "visibility", "none");
          }
        }
      }
    };
    useEffect(() => {
      // console.log(popupOptions, "popupOptions")
    }, [popupOptions]);

    const memoizedMarkerRender = useMemo(
      () =>
        points
          ?.filter((each) => {
            // if (each.factory_Code === selectedFactory) {
            //   return each;
            // } else if (selectedFactory === "Factory") {
            //   return each;
            // }
            // console.log('each point', each, filterTableData);
            if (
              selectedFactory.length === 0 &&
              selectedDepot.length === 0 &&
              selectedFormat.length === 0 &&
              selectedBasepack.length === 0
            ) {
              return each;
            } else {
              let flag1 = false,
                flag2 = false,
                flag3 = false,
                flag4 = false;
              filterTableData.forEach((e) => {
                if (e.factory_Code === each.factorycode) {
                  flag1 = true;
                }
                if (e.depot === each.depotcode) {
                  flag2 = true;
                }
                if (e.format === each.format) {
                  flag3 = true;
                }
                if (e.basepack_Code === each.basepackcode) {
                  flag4 = true;
                }
              });
              if (flag1 && flag2) {
                return each;
              }
            }
          })
          .map((el) => renderPoint(el)),
      [],
    );

    const nutritionMemoizedMarkerRender = useMemo(
      () =>
        nutritionPoints
          ?.filter((each) => {
            if (
              selectedNProcessing.length === 0 &&
              selectedNDepot.length === 0 &&
              selectedNPackaging.length === 0 &&
              selectedNBasepack.length === 0 &&
              selectedNFormat.length === 0 &&
              selectedNSFG.length === 0
            ) {
              return each;
            } else {
              let flag1 = false,
                flag2 = false,
                flag3 = false,
                flag4 = false;
              filterTableData.forEach((e) => {
                if (e.processing === each.factorycode) {
                  flag1 = true;
                }
                if (e.depot === each.depotcode) {
                  flag2 = true;
                }
                if (e.packing === each.factorycode) {
                  flag3 = true;
                }
                if (e.packing === each.depotcode) {
                  flag4 = true;
                }
              });
              if (flag1 && flag2) {
                return each;
              }
              if (flag1 && flag3) {
                return each;
              }
              if (flag2 && flag3) {
                return each;
              }
              if (flag1 && flag4) {
                return each;
              }
            }
          })
          .map((el) => renderPoint(el)),
      [],
    );

    console.log(nutritionPoints, "nutritionPoints");
    // const map1Render = useMemo(
    //   () => map1.map((el) => renderPoint(el)),
    //   [map1]
    // );

    // const map2Render = useMemo(
    //   () => map2.map((el) => renderPoint(el)),
    //   [map2]
    // );

    const wrapperStyles = {
      map: {
        height: "700px",
        width: "100%",
      },
      wrapper: {
        padding: "15px",
        marginTop: "15px",
      },
      buttonContainer: {
        display: "grid",
        gridAutoFlow: "column",
        gridGap: "10px",
        gridAutoColumns: "max-content",
        padding: "10px 0",
      },
      buttons: {
        padding: "15px",
        flex: 1,
      },
      popupStyles: {
        padding: "20px",
        color: "black",
      },
    };

    return (
      <>
        <AzureMapsProvider>
          <div style={wrapperStyles.map}>
            <AzureMap options={option}>
              <AzureMapDataSourceProvider
                events={{
                  dataadded: (e) => {
                    //    console.log("Data on source added", e);
                  },
                }}
                id={"routeExample AzureMapDataSourceProvider"}
                options={{
                  // This sample shows how to apply a stroke gradient to a line on the map.\
                  // In order to apply this feature to a line, the data source must have the lineMetrics option set to true.
                  lineMetrics: true,
                }}
              >
                <AzureMapLayerProvider
                  id={"routeExample AzureMapLayerProvider"}
                  options={{
                    // lineJoin: "round",
                    //  pathType: 'original',
                    // lineCap: "round",
                    // width: 3,
                    // lineDash: [40,10], // <- [dashLength, dashSpace]
                    strokeGradient: [
                      "interpolate",
                      ["linear"],
                      ["line-progress"],
                      0,
                      "#73706E",
                    ],
                    strokeColor: ["get", "strokeColor"],
                    strokeWidth: ["get", "strokeWidth"],
                    lineJoin: "round",
                    lineCap: "round",
                  }}
                  events={{
                    mouseOverLineString: (e) => {
                      //     console.log("liner");
                    },
                    wheel: (e) => {
                      handleZoom(e);
                    },
                    mouseleave: () => {
                      setPopupOptions(() => {});
                    },
                    // mouseenter: mouseOverLineString,
                    mousemove: (e) => {
                      return;
                      //   console.log("shapes", e?.shapes);
                      // var popupTemplate = '<div class="customInfobox"><div class="name">{name}</div>{description}</div>';
                      // var content, coordinate;
                      // var properties = e.shapes[0].getProperties();
                      if (e.shapes && e.shapes.length > 0) {
                        // var content, coordinate;
                        // var properties = e.shapes[0].getProperties();
                        // content = popupTemplate.replace(/{name}/g, properties.name).replace(/{description}/g, properties.description);
                        // coordinate = e.shapes[0].getCoordinates();
                        // console.log("shapes", e?.shapes);
                        const prop = e.target?.options;
                        // Set popup options
                        setPopupOptions({
                          ...popupOptions,
                          position: new data.Position(
                            e?.position[0],
                            e?.position[1],
                          ),
                          pixelOffset: [0, -8],
                        });
                        setPopupProperties("Position: " + popupPosition);
                        // var popup = new atlas.Popup({
                        //   pixelOffset: [0, -18],
                        //   closeButton: false
                        // });
                        // popup.setOptions({
                        //   content: "Hello",
                        //   //Update the popup's position with the symbol's coordinate.
                        //   position: e.shapes[0].getCoordinates(),
                        //   pixelOffset: [0, -18]
                        // })
                        // popup.open();
                        if (prop?.text)
                          // Set popup properties from Feature Properties that are declared on create Feature
                          setPopupProperties([...popupProperties, prop?.text]);
                      }
                    },
                  }}
                  lifecycleEvents={{
                    layeradded: (e) => {
                      //     console.log("LAYER ADDED TO MAP", e);
                    },
                  }}
                  type={"LineLayer"}
                />
                {selectedCategoryId === 1
                  ? show3 && show2 && show4
                    ? memoizedMarkerRender
                    : null
                  : show3 && show2 && show4
                    ? nutritionMemoizedMarkerRender
                    : null}
                {/* {map1Render} */}
                {show3 ? renderHTMLPoint() : null}
                {show2 ? renderFactoryPoints() : null}
                {show4 ? renderPackagingPoints() : null}
              </AzureMapDataSourceProvider>

              <AzureMapPopup
                isVisible={popupOptions ? true : false}
                options={popupOptions}
                popupContent={
                  <>
                    <div style={{ padding: "8px" }}>
                      <span>
                        {popupProperties}
                        <br /> City: {popUpContent[1]}
                      </span>
                    </div>
                  </>
                }
                // <div style={{ padding: "8px 16px" }}>
                //   <h3>{popupOptions?.data && "Position: " + popupOptions?.data[0]?.positions}</h3>
                //   <h5>{popupOptions?.data && "City: " + popupOptions?.data[0]?.City}</h5>
                // </div> // Inject your JSX
              />
            </AzureMap>
          </div>
        </AzureMapsProvider>
      </>
    );
  };

  const resetFilter = () => {
    if (!resultData?.azureMapsSTHCFilterModel) {
      return;
    }

    setFilterTableData([...resultData?.azureMapsSTHCFilterModel]);

    let list = [...resultData?.azureMapsSTHCFilterModel];

    let fcList = [],
      fmList = [],
      bpList = [],
      dpList = [];
    list.forEach((each) => {
      if (each.factory_Code) {
        // if (!fcList.includes(each.factory_Code)) {
        //   fcList.push(each.factory_Code);
        // }
        if (!fcList.some((item) => item.key === each.factory_Code)) {
          fcList.push({ key: each.factory_Code, value: each.factory_Code });
        }
      }

      if (each.depot) {
        if (!dpList.some((item) => item.key === each.depot)) {
          dpList.push({ key: each.depot, value: each.depot });
        }
      }

      if (each.format) {
        if (!fmList.some((item) => item.key === each.format)) {
          fmList.push({ key: each.format, value: each.format });
        }
      }

      if (each.basepack_Code) {
        if (!bpList.some((item) => item.key === each.basepack_Code)) {
          bpList.push({ key: each.basepack_Code, value: each.basepack_Code });
        }
      }
    });

    setFactoryList([...fcList]);

    setDepotList([...dpList]);

    setFormatList([...fmList]);

    setBasepackList([...bpList]);

    setSelectedFactory([]);
    setSelectedDepot([]);
    setSelectedFormat([]);
    setSelectedBasepack([]);
  };

  const resetNFilter = () => {
    if (!nutritionResultData?.azureMapsSTNutritionFilterModel) {
      return;
    }

    setFilterTableData([
      ...nutritionResultData?.azureMapsSTNutritionFilterModel,
    ]);

    let list = [...nutritionResultData?.azureMapsSTNutritionFilterModel];

    let nProcessingL = [],
      nSFGL = [],
      nPackagingL = [],
      nBasepackL = [],
      nFormatL = [],
      nDepotL = [];
    list.forEach((each) => {
      if (each.processing) {
        if (!nProcessingL.some((item) => item.key === each.processing)) {
          nProcessingL.push({ key: each.processing, value: each.processing });
        }
      }

      if (each.sfg) {
        if (!nSFGL.some((item) => item.key === each.sfg)) {
          nSFGL.push({ key: each.sfg, value: each.sfg });
        }
      }

      if (each.packing) {
        if (!nPackagingL.some((item) => item.key === each.packing)) {
          nPackagingL.push({ key: each.packing, value: each.packing });
        }
      }

      if (each.basepack) {
        if (!nBasepackL.some((item) => item.key === each.basepack)) {
          nBasepackL.push({ key: each.basepack, value: each.basepack });
        }
      }

      if (each.format) {
        if (!nFormatL.some((item) => item.key === each.format)) {
          nFormatL.push({ key: each.format, value: each.format });
        }
      }

      if (each.depot) {
        if (!nDepotL.some((item) => item.key === each.depot)) {
          nDepotL.push({ key: each.depot, value: each.depot });
        }
      }
    });

    // setFactoryList([...fcList]);

    // setDepotList([...dpList]);

    // setFormatList([...fmList]);

    // setBasepackList([...bpList]);

    setNProcessingList([...nProcessingL]);
    setNSFGList([...nSFGL]);
    setNPackagingList([...nPackagingL]);
    setNBasepackList([...nBasepackL]);
    setNFormatList([...nFormatL]);
    setNDepotList([...nDepotL]);

    setSelectedNProcessing([]);
    setSelectedNSFG([]);
    setSelectedNPackaging([]);
    setSelectedNBasepack([]);
    setSelectedNFormat([]);
    setSelectedNDepot([]);
  };

  return (
    <div className="App">
      {/* map-filter info */}
      <div
        className="map-filters"
        onClick={() => {
          setViewDetail(false);
          setshowMapFiltersDetails(true);
          setshowLegendDetails(false);
        }}
      >
        {/* <div className="map-filters"> */}
        <span className="direction-symbol">&#171; &nbsp;</span>
        <span>Map Filter</span>
      </div>

      {showMapFiltersDetails && (
        <div className="map-filter-panel">
          <div className="header">
            {!viewDetail && (
              <>
                <span className="pull-left">
                  <h2>Map Filter</h2>
                </span>
                <span
                  onClick={() => {
                    if (selectedCategoryId === 1) {
                      resetFilter();
                    } else {
                      resetNFilter();
                    }
                  }}
                >
                  <RestoreOutlinedIcon className="restoreIcon1" />
                </span>
              </>
            )}
            {!viewDetail ? (
              <span className="pull-right">
                <a
                  href="#"
                  className="collapse-btn"
                  onClick={() => {
                    setshowMapFiltersDetails(false);
                    selectedCategoryId === 1 ? resetFilter() : resetNFilter();
                  }}
                >
                  Collapse&nbsp; &#187;
                </a>
              </span>
            ) : // <span className="pull-right"><a href="#" className="collapse-btn" onClick={() => {
            //   setshowMapFiltersDetails(false);
            //   setViewDetail(false);
            //   resetFilter();
            // }}>Exit</a></span>
            null}
          </div>
          <div className="clear"></div>

          {!viewDetail ? (
            selectedCategoryId === 1 ? (
              <div className="filters">
                {/* <select onChange={(e) => {
                      if (e.target.value === "Factory") {
                        setSelectedFactory("");
                      } else {
                        setSelectedFactory(e.target.value);
                      }
                    }} value={selectedFactory}>
                      {
                        factoryList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedFactory}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={factoryList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedFactory(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Factory"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Depot") {
                        setSelectedDepot("");
                      } else {
                        setSelectedDepot(e.target.value);
                      }
                    }} value={selectedDepot}>
                      {
                        depotList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedDepot}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={depotList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedDepot(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Depot"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Format") {
                        setSelectedFormat("");
                      } else {
                        setSelectedFormat(e.target.value);
                      }
                    }} value={selectedFormat}>
                      {
                        formatList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedFormat}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={formatList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedFormat(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Format"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Basepack") {
                        setSelectedBasepack("");
                      } else {
                        setSelectedBasepack(e.target.value);
                      }
                    }} value={selectedBasepack}>
                      {
                        basepackList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedBasepack}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={basepackList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedBasepack(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Basepack"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              </div>
            ) : (
              <div className="filters">
                {/* <select onChange={(e) => {
                      if (e.target.value === "Processing") {
                        setSelectedNProcessing("");
                      } else {
                        setSelectedNProcessing(e.target.value);
                      }
                    }} value={selectedNProcessing}>
                      {
                        nProcessingList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNProcessing}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nProcessingList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNProcessing(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Factory"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "SFG") {
                        setSelectedNSFG("");
                      } else {
                        setSelectedNSFG(e.target.value);
                      }
                    }} value={selectedNSFG}>
                      {
                        nSFGList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNSFG}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nSFGList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNSFG(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="SFG"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Packaging") {
                        setSelectedNPackaging("");
                      } else {
                        setSelectedNPackaging(e.target.value);
                      }
                    }} value={selectedNPackaging}>
                      {
                        nPackagingList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNPackaging}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nPackagingList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNPackaging(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Packaging"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Basepack") {
                        setSelectedNBasepack("");
                      } else {
                        setSelectedNBasepack(e.target.value);
                      }
                    }} value={selectedNBasepack}>
                      {
                        nBasepackList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNBasepack}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nBasepackList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNBasepack(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Basepack"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Format") {
                        setSelectedNFormat("");
                      } else {
                        setSelectedNFormat(e.target.value);
                      }
                    }} value={selectedNFormat}>
                      {
                        nFormatList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNFormat}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nFormatList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNFormat(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Format"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
                {/* <select onChange={(e) => {
                      if (e.target.value === "Depot") {
                        setSelectedNDepot("");
                      } else {
                        setSelectedNDepot(e.target.value);
                      }
                    }} value={selectedNDepot}>
                      {
                        nDepotList.map((each, idx) => (
                          <option key="idx" value={each}>{each}</option>
                        ))
                      }
                    </select> */}
                <FormControl sx={{ width: 200 }}>
                  <Autocomplete
                    value={selectedNDepot}
                    multiple
                    id="checkboxes-tags-demo-new"
                    options={nDepotList}
                    limitTags={1}
                    onChange={(e, item) => {
                      setSelectedNDepot(item);
                    }}
                    autoComplete
                    includeInputInList
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.key}
                    renderOption={(props, option, { selected }) => {
                      // debugger;
                      return (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.key}
                        </li>
                      );
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Depot"
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              </div>
            )
          ) : (
            <div className="sidePanel-title">
              <div className="pull-left">
                <h2 className="sidepanel-header">{currentDetail.heading}</h2>
                <img
                  src={
                    currentDetail.imgUrl
                      ? currentDetail.imgUrl
                      : processingPlant
                  }
                  className="title-icon"
                ></img>
                <span className="text-indent">{currentDetail.text}</span>
                <span>|</span>
                <span>{currentDetail.title}</span>
                <span>|</span>
                <span>
                  {currentDetail.latitude}, {currentDetail.longitude}
                </span>
              </div>
              <div className="pull-right">
                <span>
                  <a
                    href="#"
                    className="collapse-btn1"
                    onClick={() => {
                      setshowMapFiltersDetails(false);
                      setViewDetail(false);

                      selectedCategoryId === 1 ? resetFilter() : resetNFilter();
                    }}
                  >
                    Exit <span className="small-font">&#10060;</span>
                  </a>
                </span>
              </div>
            </div>
          )}
          <br></br>
          <div className="filter-dataTable scrollbar">
            {selectedCategoryId === 1 ? (
              <table cellPadding={0} cellSpacing={0}>
                <tr>
                  <th>Factory</th>
                  <th>Depot</th>
                  <th>Basepack</th>
                  <th>CO2</th>
                  <th>Demand Location Code</th>
                  <th>Distance</th>
                  <th>Format</th>
                  <th>Time Period</th>
                </tr>
                {filterTableData.map((each, idx) => (
                  <tr key="idx">
                    <td>{each.factory_Code}</td>
                    <td>{each.depot}</td>
                    <td>{each.basepack_Code}</td>
                    <td>{each.cO2}</td>
                    <td>{each.demand_Location_Code}</td>
                    <td>{each.distance}</td>
                    <td>{each.format}</td>
                    <td>{each.time_Period}</td>
                  </tr>
                ))}
              </table>
            ) : (
              <table cellPadding={0} cellSpacing={0}>
                <tr>
                  <th>Processing</th>
                  <th>SFG</th>
                  <th>Packaging</th>
                  <th>Basepack</th>
                  <th>Format</th>
                  <th>Depot</th>
                  <th>Volume</th>
                  <th>CO2</th>
                </tr>
                {filterTableData.map((each, idx) => (
                  <tr key="idx">
                    <td>{each.processing}</td>
                    <td>{each.sfg}</td>
                    <td>{each.packing}</td>
                    <td>{each.basepack}</td>
                    <td>{each.format}</td>
                    <td>{each.depot}</td>
                    <td>{each.volume}</td>
                    <td>{each.cO2}</td>
                  </tr>
                ))}
              </table>
            )}
          </div>
          <br></br>
          {/* <div className="filter-dataTable scrollbar">
            <table cellPadding={0} cellSpacing={0}>
              <tr>
                <th>Pro Plant</th>
                <th>Depot</th>
                <th>Flow</th>
                <th>RM/PM landed cost</th>
                <th>Processing cost + Packaging cost</th>
                <th>SFG trasportation cost</th>
                <th>Primary transportation cost</th>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
              <tr>
                <td>Khanpur</td>
                <td>Agra</td>
                <td>200</td>
                <td>48712</td>
                <td>23231</td>
                <td>32472</td>
                <td>10209</td>
              </tr>
            </table>
          </div> */}
        </div>
      )}

      {/* --//-- */}
      {/* legends info */}
      <div className="map-legend" onClick={() => setshowLegendDetails(true)}>
        {/* <span><img src={locator} ></img></span> */}
        <span className="direction-symbol">&#171; &nbsp;</span>
        <span>Legend</span>
        {showLegendDetails && (
          <span
            href="#"
            onClick={(e) => {
              e.stopPropagation();
              setshowLegendDetails(false);
            }}
          >
            &nbsp;&#10060;
          </span>
        )}
      </div>

      {showLegendDetails && renderLegendOptions()}

      <div className="legends-panel hide" id="longTerm-scenario">
        <ul>
          <li>
            <img src={processingPlant}></img>
          </li>
          <li>
            <span>Processing Plant</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={processingPlantAdd}></img>
          </li>
          <li>
            <span>Processing Plant Add</span>
          </li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={processingPlantCapacity}></img>
          </li>
          <li>
            <span>Processing Plant Capacity Add</span>
          </li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={processingPlantRemove}></img>
          </li>
          <li>
            <span>Processing Plant Remove</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={packagingPlant1}></img>
          </li>
          <li>
            <span>Packaging Plant</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={packagingPlant2}></img>
          </li>
          <li>
            <span>Packaging Plant</span>
          </li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={packagingPlantCapacity}></img>
          </li>
          <li>
            <span>Packaging Plant Capacity Add</span>
          </li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={packagingPlantRemove}></img>
          </li>
          <li>
            <span>Packaging Plant Remove</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={locator}></img>
          </li>
          <li>
            <span>Depots</span>
          </li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={supplierMap}></img>
          </li>
          <li>
            <span>Supplier</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={inBoundLine}></img>
          </li>
          <li>
            <span>In-bound to packaging plant from Processing plant</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <span className="barliine">____</span>
          </li>
          <li>
            <span>In-bound to Depot from Packging</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
        <ul>
          <li>
            <img src={inBoundtoSupplier}></img>
          </li>
          <li>
            <span>In bound to Processing Pant from Supplier</span>
          </li>
          <li></li>
          <li>
            <input type="checkbox" className="pull-right" />
          </li>
        </ul>
      </div>

      <div className="legends-panel hide" id="mediumTerm-scenario">
        <ul>
          <li>
            <img src={marker3}></img>
          </li>
          <li>
            <span>Processing Plant</span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
        <ul>
          <li>
            <img src={processingPlantCapacity}></img>
          </li>
          <li>
            <span>Processing Plant Capacity Add</span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
        <ul>
          <li>
            <img src={packagingPlant1}></img>
          </li>
          <li>
            <span>Packaging Factory</span>
          </li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
          <li></li>
        </ul>
        <ul>
          <li>
            <img src={packagingPlantCapacity}></img>
          </li>
          <li>
            <span>Packaging plant to Capacity Add</span>
          </li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
          <li></li>
        </ul>
        <ul>
          <li>
            <img src={locator}></img>
          </li>
          <li>
            <span>Depots</span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
        <ul>
          <li>
            <img src={inBoundLine}></img>
          </li>
          <li>
            <span>In-bound to packaging plant from Processing plant</span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
        <ul>
          <li>
            <span className="barliine">____</span>
          </li>
          <li>
            <span>Inbound to Depot from Packaging </span>
          </li>
          <li></li>
          {/* <li><input type="checkbox" className="pull-right" /></li> */}
        </ul>
      </div>
      <div className="over">
        <MarkersExample />
      </div>

      {/* { selectedCategoryId !== 1 ? <div className='overlap'>
           <span className='legendtotal'>
           <span className='legend'>
             <img alt="legendimage" src={marker1} className='legendimage'></img>
             <p className='para'>Depot</p>
           </span>
           <span className='legend'>
             <img alt="legendimage" src={marker3} className='legendimage'></img>
             <p className='para'>Factory</p>
           </span>
           <span className='legend'>
             <img alt="legendimage" src={products} className='legendimage'></img>
             <p className='para'>Packaging</p>
           </span>
           <span className='legend'>
             <img alt="legendimage" src={capacity} className='legendimage'></img>
             <p className='para'>Factory (Add)</p>
           </span>
           </span>
       </div> : <div className='overlap'>
             <span className='legendtotal'>
             <span className='legend'>
               <img alt="legendimage" src={marker1} className='legendimage'></img>
               <p className='para'>Depot</p>
             </span>
             <span className='legend'>
               <img alt="legendimage" src={marker3} className='legendimage'></img>
               <p className='para'>Factory</p>
             </span>
             <span className='legend'>
               <img alt="legendimage" src={capacity} className='legendimage'></img>
               <p className='para'>Factory (Add)</p>
             </span>

             </span>
       </div> } */}
    </div>
  );
}
